// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.actions-container[data-v-06b441e2] {\r\n  padding-top: 2rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
